import Vue from 'vue';
import VueI18n from 'vue-i18n';
import view_zh from 'iview/dist/locale/zh-CN';
import view_en from 'iview/dist/locale/en-US';
import view_pt from 'iview/dist/locale/pt-PT';
import iview from "iview";
Vue.use(VueI18n)

const messagesConfig = {
        'zh-CN': Object.assign(require('../../common/language/zh-CN'),view_zh),
        'en-US': Object.assign(require('../../common/language/en-US'),view_en),
        'pt-PT': Object.assign(require('../../common/language/pt-PT'),view_pt)
}
var i18n = new VueI18n({
    locale:localStorage.getItem("language")?localStorage.getItem("language"):'zh-CN',
    messages:messagesConfig,
    silentTranslationWarn: true
})
// 防止 this.$Modal 报错 加上之后出现iview部分组件不能切换英文
Vue.use(iview, {
    i18n: function(path, options) {
        let value = i18n.t(path, options)
        if (value !== null && value !== undefined) {
            return value
        }
        return '';
    }
})

export default i18n



